export const officeAddress = "Sunway Tower, Level 19, \n86, Jalan Ampang, Kuala Lumpur, \n50300 Kuala Lumpur, \nWilayah Persekutuan Kuala Lumpur";
export const contactNumber = "+6012-8363255";
export const enquiryEmail = "enquiry@bizmate2u.com";
export const loginUrl = "https://member.bizmate2u.com/auth";
export const registerUrl = "https://member.bizmate2u.com/auth/register";
export const salesContactLink = "https://api.whatsapp.com/send?phone=60128363255";